import React, { Fragment, useState, useContext, useEffect, useImperativeMethods } from "react";
import styled from "styled-components";
import Unit from "./inputs/Unit";
import Qualifier from "./inputs/Qualifier";
import TestnameInput from "../testing/TestnameInput";
import Input from "../Input";
import Link from "../Link";
import SmallNumberInput from "./inputs/SmallNumberInput";
import { useTestResultsContext } from "./contexts/TestResultsContext";

const Td = styled.td`
  white-space: nowrap;
`;

export default function TestResult({ sample_test, test, sample_id }) {
  const { state, updateResult } = useTestResultsContext();

  const stateResult = state.results[sample_test.id] || {};

  const [lod, setLod] = useState(stateResult.lod || test.lod);
  const [lod_top_unit_id, setLodTopUnitId] = useState(
    stateResult.lod_top_unit_id || test.top_unit_id
  );
  const [lod_bottom_unit_id, setLodBottomUnitId] = useState(
    stateResult.lod_bottom_unit_id || test.bottom_unit_id
  );
  const [top_unit_id, setTopUnitId] = useState(stateResult.top_unit_id || test.top_unit_id);
  const [bottom_unit_id, setBottomUnitId] = useState(
    stateResult.bottom_unit_id || test.bottom_unit_id
  );
  const [qualifier, setQualifier] = useState(stateResult.qualifier || 2);
  const [value, setValue] = useState(stateResult.value);
  const [testname_id, setTestnameId] = useState(stateResult.testname_id);
  const [showTestnameInput, setShowTestnameInput] = useState(!!stateResult.testnameId);

  useEffect(() => {
    if (stateResult.qualifier && qualifier != stateResult.qualifier) {
      setQualifier(stateResult.qualifier);
    }
  }, [stateResult.qualifier]);

  useEffect(() => {
    updateResult({
      sampleTestId: sample_test.id,
      result: {
        sample_id,
        sample_test_id: sample_test.id,
        lod,
        lod_top_unit_id,
        lod_bottom_unit_id,
        top_unit_id,
        bottom_unit_id,
        qualifier,
        value,
        testname_id
      }
    });
  }, [
    lod,
    lod_top_unit_id,
    lod_bottom_unit_id,
    top_unit_id,
    bottom_unit_id,
    qualifier,
    value,
    testname_id
  ]);

  // Clear value when qualifier changes to anything that isn't = or >
  useEffect(() => {
    if (![2, 3].includes(qualifier)) {
      setValue(null);
    }
  }, [qualifier]);

  const handleQualifierChange = id => {
    setQualifier(parseInt(id));
  };

  const showValue = [2, 3].includes(qualifier);

  return (
    <Fragment>
      <Td>
        <SmallNumberInput value={lod} onChange={setLod} width={50} />
        <Unit unit_id={lod_top_unit_id} onChange={setLodTopUnitId} />
        <Unit unit_id={lod_bottom_unit_id} onChange={setLodBottomUnitId} />
      </Td>
      <Td style={{ minWidth: 40 }}>
        <Qualifier value={qualifier} onChange={handleQualifierChange} />
      </Td>
      <Td>
        {showValue && (
          <Fragment>
            <SmallNumberInput value={value} onChange={setValue} width={60} />
            <Unit unit_id={top_unit_id} onChange={setTopUnitId} />
            <Unit unit_id={bottom_unit_id} onChange={setBottomUnitId} />
          </Fragment>
        )}
      </Td>
      <Td>
        {showTestnameInput ? (
          <Fragment>
            <TestnameInput
              width={200}
              multiple={false}
              onChange={option => setTestnameId(option ? option.value : null)}
            />
            <Link
              onClick={() => {
                setTestnameId(null);
                setShowTestnameInput(!showTestnameInput);
              }}
            >
              Remove
            </Link>
          </Fragment>
        ) : (
          <Link onClick={() => setShowTestnameInput(!showTestnameInput)}>Add</Link>
        )}
      </Td>
      <Td />
    </Fragment>
  );
}
